// extracted by mini-css-extract-plugin
export default {"tabWrapper":"styles_tabWrapper__FiI1q","tabItem":"styles_tabItem__ki52H","active":"styles_active__277am"};